// Config
import { OriginSize } from "shared/origin";
import { Main } from "screens/main";
import { BuildConfig, FontsConfig } from "shared/config";
import { TextHelper } from "shared/helpers";
import { BarStorage, GameHeaderStorage, CounterStorage, GameViewStorage, LocElementsStorage } from "shared/storages";
import { Game } from "../game";
import { LanguageService, LoaderService, PopupsService } from "shared/services";
import { LevelObject } from "shared/levels";

export class GameService {
    private screen: PIXI.Container;

    public init(screen: PIXI.Container): void {
        this.screen = screen;
        const map = new PIXI.Container();
        map.name = 'map_container';
        const bg = new PIXI.Sprite(LoaderService.getResource('mobile_bg').texture);
        bg.width = OriginSize.width;
        bg.height = OriginSize.height;
        bg.x = 0;
        bg.y = 0;
        map.addChild(bg);
        screen.addChild(map);
    }

    public createHeader(screen: PIXI.Container): void {
        const block = new PIXI.Container;
        block.name = 'header';
        const graphics = new PIXI.Graphics();
        graphics.beginFill(0xffffff);
        graphics.drawRect(0, 0, screen.width, 225);
        graphics.name = 'white_bg'
        block.addChild(graphics);
        this.addElementsToHeder(block);
        block.zIndex = 1000;
        GameHeaderStorage.header = block;
        GameHeaderStorage.originHeaderY = block.y;
        block.pivot.set(0);
        block.y = block.y + GameViewStorage.headerShift;
        screen.addChild(block);
    }

    private addElementsToHeder(container: PIXI.Container): void {
        const pauseBtn = new PIXI.Sprite(LoaderService.getSpritesheet('main_sprites').textures['Pause_Button.png']);
        pauseBtn.name = 'pause_btn'
        pauseBtn.width = container.height - 110;
        pauseBtn.height = container.height - 110;
        pauseBtn.x = 50;
        pauseBtn.y = 50;
        pauseBtn.interactive = true;
        pauseBtn.buttonMode = true;
        pauseBtn.on('pointerup', () => {

            if (PopupsService.isComplete) {
                return;
            }

            //@ts-ignore
            if (dataLayer) {
                //@ts-ignore
                dataLayer.push({
                    'event': 'uaevent',
                    'ecommerce': undefined,
                    'eventCategory': 'match the ink game',
                    'eventAction': 'select',
                    'eventLabel': 'pause',
                })
            }
            Game.instance.blurScreen(true);
            const levelHtml = document.getElementById('pause_level');
            const pause = document.getElementById('pause');
            const substate = document.getElementById('blackout_substate');
            const level = Game.instance.currentMechanic.level.num;
            levelHtml.innerHTML = `${level}`
            substate.style.display = 'block';
            pause.style.display = 'flex';
        })

        const pauseShadow = new PIXI.Sprite(LoaderService.getSpritesheet('main_sprites').textures['Btn_pause_shadow.png']);
        pauseShadow.width = pauseBtn.width + 130;
        pauseShadow.height = pauseBtn.height + 130;
        pauseShadow.x = -1;
        pauseShadow.y = 0;

        const pauseText = new PIXI.Text('PAUSE');
        LocElementsStorage.elements.push({ loc_pixi_pause: pauseText });
        pauseText.style = new PIXI.TextStyle({
            fontFamily: FontsConfig.fonts.Neue_Helvetica_bold,
            fontSize: 50,
            fill: 0x000000,
            letterSpacing: 4.75,
            fontWeight: 'bold'
        })
        pauseText.x = pauseBtn.x + pauseBtn.width + 35;
        pauseText.y = pauseBtn.y + pauseBtn.height / 3;
        pauseText.interactive = true;
        pauseText.buttonMode = true;


        const scoreGraphics = new PIXI.Graphics();
        scoreGraphics.beginFill(0xFC2561);
        scoreGraphics.drawRect(container.width - 500, GameHeaderStorage.maskY, OriginSize.width / 2, container.height);
        scoreGraphics.endFill();
        scoreGraphics.name = 'mask';
        scoreGraphics.zIndex = 300;
        const scoreMask = new PIXI.Text('0')
        scoreMask.name = 'score_mask';
        scoreMask.zIndex = 200;
        scoreMask.style = new PIXI.TextStyle({
            fontFamily: FontsConfig.fonts.Helvetica_Neue,
            fontSize: 120,
            stroke: 0xFC2561,
            fill: 0xffffff,
            letterSpacing: 7,
            strokeThickness: 10,
        });
        scoreMask.x = container.width - 220;
        scoreMask.y = 30;
        scoreGraphics.mask = scoreMask;
        GameHeaderStorage.maskY = scoreGraphics.y;
        GameHeaderStorage.scoreMask = scoreMask;
        GameHeaderStorage.container = container;
        GameHeaderStorage.mask = scoreGraphics;

        const scoreText = new PIXI.Text('0');
        scoreText.style = new PIXI.TextStyle({
            fontFamily: FontsConfig.fonts.Helvetica_Neue,
            fontSize: 120,
            stroke: 0xFC2561,
            fill: 0xffffff,
            letterSpacing: 7,
            strokeThickness: 10,
        });
        scoreText.x = container.width - 220;
        scoreText.y = 30;
        GameHeaderStorage.score = scoreText;

        const ptsText = new PIXI.Text('PTS');
        LocElementsStorage.elements.push({ loc_pixi_pts: ptsText });
        ptsText.style = new PIXI.TextStyle({
            fontFamily: FontsConfig.fonts.Helvetica_Neue,
            fill: 0x333333,
            fontSize: 50,
        })
        ptsText.x = container.width - 120;
        ptsText.y = 50;

        const persentText = new PIXI.Text('0%');
        persentText.style = new PIXI.TextStyle({
            fontFamily: FontsConfig.fonts.Helvetica_Neue,
            fill: 0xFC2561,
            fontSize: 50,
        })
        persentText.x = container.width - 120;
        persentText.y = 110;
        GameHeaderStorage.persent = persentText;

        container.addChild(pauseShadow, pauseBtn, pauseText,
            scoreText, scoreGraphics, scoreMask, ptsText, persentText)
    }

    public createBar(container: PIXI.Container) {
        const bar = new PIXI.Container;
        bar.name = 'bar';
        const barMainSubstrate = new PIXI.Container;
        barMainSubstrate.name = 'bar_main_substrate'
        const graphics = new PIXI.Graphics();
        graphics.lineStyle(5, 0xffffff);
        graphics.drawRect(25, 450, OriginSize.width - 50, 185);
        graphics.endFill();
        barMainSubstrate.addChild(graphics);

        const barAlpha = new PIXI.Container();
        const barAlphaGraphics = new PIXI.Graphics();
        barAlphaGraphics.beginFill(0x000000);
        barAlphaGraphics.drawRect(30, 455, barMainSubstrate.width - 15, barMainSubstrate.height - 15);
        barAlpha.addChild(barAlphaGraphics);
        barAlpha.alpha = 0.3;

        const spriteAlpha = new PIXI.Sprite(LoaderService.getSpritesheet('main_sprites').textures['Product1.png']);
        spriteAlpha.x = 85;
        spriteAlpha.y = 465;
        spriteAlpha.width = barMainSubstrate.width - 130;
        spriteAlpha.height = barMainSubstrate.height - 30;
        spriteAlpha.alpha = 0.4;

        const barMain = new PIXI.Container();
        barMain.name = 'bar_main'


        const barMainSprite = new PIXI.Sprite(LoaderService.getSpritesheet('main_sprites').textures['Progress_bar_fill.png']);
        barMainSprite.y = 464;
        barMainSprite.x = 37;
        barMainSprite.width = barMainSubstrate.width - 30;
        barMainSprite.height = barMainSubstrate.height - 30;
        barMainSprite.alpha = 1;

        const sprite = new PIXI.Sprite(LoaderService.getSpritesheet('main_sprites').textures['Product1.png']);
        sprite.x = 85;
        sprite.y = 465;
        sprite.width = barMainSubstrate.width - 130;
        sprite.height = barMainSubstrate.height - 30;
        sprite.alpha = 1;

        const maskGraphics = new PIXI.Graphics();
        maskGraphics.name = 'mask_graphics'
        maskGraphics.beginFill();
        maskGraphics.drawRect(30 - graphics.width, 455, graphics.width, barMainSubstrate.height - 15);
        maskGraphics.isMask = true;
        // (barMainSubstrate.width - 15) / 2
        maskGraphics.endFill();
        barMain.addChild(maskGraphics)
        barMain.mask = maskGraphics;
        BarStorage.maskOriginX = maskGraphics.x;
        BarStorage.maxScore = barMainSubstrate.width;
        BarStorage.barMask = maskGraphics;
        BarStorage.barMain = barMain;

        const flare = new PIXI.Sprite(LoaderService.getSpritesheet('main_sprites').textures['bar_flare.png']);
        flare.width = 50;
        flare.name = 'bar_flare';
        flare.height = barMainSubstrate.height + 150;
        flare.x = 30;
        flare.y = 380;
        flare.blendMode = PIXI.BLEND_MODES.ADD;
        flare.alpha = 0;
        BarStorage.flare = flare;
        BarStorage.flareX = flare.x;

        const barPersent = new PIXI.Text('0%');
        barPersent.style = new PIXI.TextStyle({
            fontFamily: FontsConfig.fonts.Helvetica_Neue,
            fill: 0xffffff,
            fontSize: 60,
        })
        barPersent.x = barMainSubstrate.width / 2 - 20;
        barPersent.y = 505;
        BarStorage.barPersend = barPersent;

        const tileRemaining = new PIXI.Text('36 TILES REMAINING');
        tileRemaining.style = new PIXI.TextStyle({
            fontFamily: FontsConfig.fonts.Helvetica_Neue,
            fill: 0xffffff,
            fontSize: 45,
        })
        tileRemaining.x = barMainSubstrate.width / 3 + 20;
        tileRemaining.y = 680;

        barMainSubstrate.addChild(barAlpha, spriteAlpha);
        barMain.addChild(barMainSprite, sprite)
        bar.addChild(barMainSubstrate, barMain, flare, barPersent);
        container.addChild(bar)
        GameViewStorage.bar = bar;
        GameViewStorage.originBarY = bar.y;
        return [barMainSubstrate, barMain, flare, barPersent]
    }

    public createProductCounter(container: PIXI.Container) {
        const textContainet = new PIXI.Container;
        const counter = new PIXI.Text('0/3');
        counter.style = new PIXI.TextStyle({
            fontFamily: FontsConfig.fonts.Neue_Helvetica_bold,
            fontSize: 100,
            fill: 0xF1F1F1,
            letterSpacing: 7,
            fontWeight: 'bold'
        })
        const text = new PIXI.Text(LanguageService.getTranslation('loc_tiles_dropped'));
        text.style = new PIXI.TextStyle({
            fontFamily: FontsConfig.fonts.Helvetica_Neue,
            fill: 0xF1F1F1,
            fontSize: 50,
            align: 'center',
        })
        textContainet.x = container.width / 2 - LevelObject.tilesMargin * 3 - 10;
        textContainet.y = 400;
        text.y = 100;
        text.anchor.set(0.35);
        // text.x = -(text.width / 2);
        textContainet.addChild(counter, text);
        CounterStorage.counter = counter;
        container.addChild(textContainet);
        GameViewStorage.productCounter = textContainet;
        GameViewStorage.productCounterOriginY = textContainet.y;
        return [textContainet];
    }

    public createMixScreen(container): void {
        const block = new PIXI.Container();
        const bg = new PIXI.Sprite(LoaderService.getResource('mix_bg').texture);
        const noMovesTest = new PIXI.Text(LanguageService.getTranslation('loc_no_moves'));
        const title = new PIXI.Sprite(LoaderService.getResource('mix_title').texture);
        const btn = new PIXI.Sprite(LoaderService.getResource('mix_btn').texture);
        const text = new PIXI.Text(LanguageService.getTranslation('loc_press_to_shuffle'))
        noMovesTest.style = new PIXI.TextStyle({
            fontFamily: FontsConfig.fonts.Neue_Helvetica_bold,
            fontSize: 65,
            fill: 0x000000,
            letterSpacing: 4.75,
            fontWeight: 'bold',
            align: "center"
        });
        text.style = new PIXI.TextStyle({
            fontFamily: FontsConfig.fonts.Neue_Helvetica_bold,
            fontSize: 50,
            fill: 0xffffff,
            letterSpacing: 4.75,
            fontWeight: 'bold',
            align: "center"
        });
        bg.x = container.x;
        bg.y = container.y + 225;
        bg.width = container.width;
        bg.height = container.height - 225;
        noMovesTest.y = 1055;
        title.x = 125;
        title.y = 950;
        title.width = container.width - 250;
        title.height = 250;
        btn.x = container.width / 2 - 100;
        btn.y = title.y + 350;
        btn.name = 'mix_btn';
        block.on('pointerup', () => {
            Game.instance.toggleMixScreen(false);
            Game.instance.currentMechanic.shuffle();
        });

        // text.anchor.set(0.5);
        // text.x = btn.x - 80;
        // text.x = text.width;
        text.y = btn.y + 200;
        bg.alpha = 0.5;
        block.name = 'mix_screen';
        block.zIndex = 950;
        block.alpha = 0;
        block.addChild(bg, title, btn, text, noMovesTest);
        text.x = (block.width - text.width) / 2;
        noMovesTest.x = (block.width - noMovesTest.width) / 2;
        noMovesTest.angle = -2;
        block.zIndex = 20000;
        Main.instance.app.stage.addChild(block);
    }
}